"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./PlaceholderImage.style"));

var img_placeholder_thumbnail_svg_1 = tslib_1.__importDefault(require("../../assets/img-placeholder-thumbnail.svg"));

var img_placeholder_error_thumbnail_svg_1 = tslib_1.__importDefault(require("../../assets/img-placeholder-error-thumbnail.svg"));

function PlaceHolderImage(_ref) {
  var src = _ref.src,
      hasError = _ref.hasError;
  return jsx_runtime_1.jsx("img", {
    css: [src && !hasError && styles.customSrc],
    src: hasError ? img_placeholder_error_thumbnail_svg_1.default : src || img_placeholder_thumbnail_svg_1.default,
    alt: "placeholder thumbnail"
  }, void 0);
}

exports.default = react_1.memo(PlaceHolderImage);